<div class="container">
    <div class="card border-0 shadow my-5">
        <div class="card-body p-5">
            <h2>Doorverwijzen....</h2>
            <div style="height: 1200px;"></div>
        </div>
    </div>
</div>